var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgJcbLogo = function SvgJcbLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 0.208,
    width: 28.75,
    height: 19.583,
    rx: 2.292,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 0.417
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 10.24c.428.009.859-.02 1.285.014.432.08.536.735.152.949-.261.14-.572.052-.856.077h-.58v-1.04zm1.533-1.178c.095.336-.229.637-.552.591h-.98c.006-.317-.014-.66.01-.96.392.011.788-.023 1.179.018.168.042.308.18.343.351zm2.36-4.978c.018.641.002 1.316.008 1.97-.002 2.66.002 5.319-.003 7.978-.017.997-.9 1.863-1.89 1.883-.99.004-1.981 0-2.972.001v-4.02c1.08-.006 2.16.011 3.239-.008.5-.032 1.049-.362 1.072-.913.059-.553-.463-.936-.958-.996-.19-.005-.185-.056 0-.078.472-.102.843-.59.704-1.08-.118-.516-.687-.715-1.16-.714-.966-.006-1.932 0-2.897-.003.006-.75-.013-1.502.01-2.252.077-.978.982-1.785 1.958-1.768h2.889z",
    fill: "url(#jcbLogo_svg__paint0_linear_6984_988)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.228 5.954c.024-.996.911-1.854 1.9-1.869.987-.003 1.974 0 2.96-.001-.002 3.329.006 6.659-.003 9.988-.038.983-.916 1.825-1.893 1.843-.99.003-1.978 0-2.967.001V11.76c.96.227 1.968.324 2.948.173.586-.094 1.226-.382 1.425-.99.146-.52.064-1.066.085-1.6V8.104H9.987c-.007.82.016 1.64-.012 2.459-.046.503-.544.823-1.018.806-.589.006-1.755-.427-1.755-.427-.003-1.535.017-3.458.026-4.988z",
    fill: "url(#jcbLogo_svg__paint1_linear_6984_988)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.722 8.604c-.09.019-.018-.304-.04-.427.005-.774-.014-1.55.01-2.324.076-.983.988-1.792 1.968-1.769h2.885c-.002 3.33.006 6.659-.004 9.988-.038.983-.915 1.825-1.893 1.843-.989.004-1.978 0-2.967.001v-4.553c.676.554 1.594.64 2.435.642.634 0 1.265-.098 1.881-.244v-.834c-.694.346-1.51.565-2.28.367a1.241 1.241 0 01-.918-1.207c-.062-.576.276-1.184.842-1.356.703-.22 1.47-.052 2.128.235.141.074.285.165.228-.07V8.24c-1.102-.263-2.275-.36-3.382-.074a2.48 2.48 0 00-.893.438z",
    fill: "url(#jcbLogo_svg__paint2_linear_6984_988)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcbLogo_svg__paint0_linear_6984_988",
    x1: 18.103,
    y1: 9.747,
    x2: 22.97,
    y2: 9.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcbLogo_svg__paint1_linear_6984_988",
    x1: 7.121,
    y1: 10.113,
    x2: 12.009,
    y2: 10.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcbLogo_svg__paint2_linear_6984_988",
    x1: 12.674,
    y1: 9.862,
    x2: 17.544,
    y2: 9.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
};
export default SvgJcbLogo;